// extracted by mini-css-extract-plugin
module.exports = {"root":"ModalInventoryLogs_root__2uBo2","log":"ModalInventoryLogs_log__3OVB2","date":"ModalInventoryLogs_date___8Dpe","userName":"ModalInventoryLogs_userName__XjOnp"};